module.exports = __webpack_public_path__ + "img/image01_sp.57c00cd2.jpg";